import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { FaChevronDown } from 'react-icons/fa'; // Import the icon

type Props = {};

const TimeTablePrayerDocLinks = (props: Props) => {
  const [isPrayerTimeOpen, setIsPrayerTimeOpen] = useState(false);
  const location = useLocation();

  return (
    <div className="relative">
      <button
        onClick={() => setIsPrayerTimeOpen(!isPrayerTimeOpen)} // Toggle submenu
        className={`w-full text-left p-3 mb-2 rounded-lg hover:bg-gray-700 transition-colors duration-200 flex items-center justify-between ${
          location.pathname.includes('prayertime') ? 'relative' : ''
        }`}
      >
        {location.pathname.includes('timetable') && (
          <span className="absolute top-1 left-[14px] w-3 h-3 bg-blue-500 rounded-full"></span>
        )}
        <span className="ml-4">TimeTable Prayer</span>
        <FaChevronDown
          className={`transition-transform ${
            isPrayerTimeOpen ? 'transform rotate-180' : ''
          }`}
        />
      </button>

      {/* Submenu with smoother Tailwind CSS transition */}
      <div
        className={`overflow-hidden px-2 py-1 transition-all duration-300 ease-in-out ${
          isPrayerTimeOpen ? 'max-h-[200px] opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="pl-4">
          <NavLink
            to="timetable/shortcodes" // Submenu item 1
            className={({ isActive }) =>
              `block p-2 mb-2 rounded-lg hover:bg-gray-700 transition-colors duration-200 ${
                isActive ? 'bg-gray-700' : ''
              }`
            }
          >
            Shortcodes
          </NavLink>
          {/* <NavLink
            to="timetable/blocks" // Submenu item 2
            className={({ isActive }) =>
              `block p-2 mb-2 rounded-lg hover:bg-gray-700 transition-colors duration-200 ${
                isActive ? 'bg-gray-700' : ''
              }`
            }
          >
            Blocks
          </NavLink> */}
        </div>
      </div>
    </div>
  );
};

export default TimeTablePrayerDocLinks;
